import styled from 'styled-components'

export const TabContainer = styled.div`
  height: 100%;
  overflow: hidden;
`
export const DashboardContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 40px - 1rem);

  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
`
